import { List } from "immutable";
import { StringHelper } from "../../utilities/contracts/string-helper";
import { AlertNotification } from "./alert-notification.model";

export class NotificationItem {
  readonly specificDay: string;
  readonly notificationGroup: AlertNotification[];

  constructor(options: {
    specificDay: string;
    notificationGroup: AlertNotification[];
  }) {
    this.specificDay = StringHelper.clean(options.specificDay);
    this.notificationGroup = options.notificationGroup;
  }
}

